import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Icon, Table, View, Text, TableColumnOpcoes, TableSearch } from '@components';
import { getFolgas, deleteFolgas } from '@ducks/conectoresFolgas';
import { formatDateTimeS } from '@utils';

export default function TableFolgas() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const folgas = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('folgas').toArray());
  const loadingFolgas = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('loadingFolgas'));
  const successDeleteFolgas = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('successDeleteFolgas'));

  const handleSearch = () => {
    dispatch(getFolgas());
  };

  useEffect(() => {
    handleSearch();
  }, []);

  useEffect(() => {
    if (successDeleteFolgas) handleSearch();
  }, [successDeleteFolgas]);

  const excluirFolgas = (id) => {
    dispatch(deleteFolgas(id));
  };

  const columns = [
    {
      title: 'Descrição',
      dataIndex: 'obs',
      key: 'obs',
      ...TableSearch('obs', 'descrição', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Início',
      dataIndex: 'dtInicio',
      key: 'dtInicio',
      align: 'center',
      ...TableSearch('dtInicio', 'início', { st1, setSt1, st2, setSt2 }),
      render: (text) => (
        <View>
          <Text>{formatDateTimeS(text)}</Text>
        </View>
      ),
    },
    {
      title: 'Fim',
      dataIndex: 'dtFim',
      key: 'dtFim',
      align: 'center',
      ...TableSearch('dtFim', 'fim', { st1, setSt1, st2, setSt2 }),
      render: (text) => (
        <View>
          <Text>{formatDateTimeS(text)}</Text>
        </View>
      ),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '15%',
      render: (text, folga) => (
        <TableColumnOpcoes>
          <Icon.Edit action={() => history.push(`/conectores/folga/${folga.id}`)} />
          <Icon.Delete popConfirmTitle={'Deseja excluir a folga?'} action={() => excluirFolgas(folga.id)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey="id" columns={columns} dataSource={folgas} loading={loadingFolgas} hidePagination />;
}
